export interface DashboardOption {
  value: string;
  name: string;
  description: string;
  // When true, the tile opens an external URL in a new tab instead of routing
  // internally. This constant must NOT import CONFIG, as configuration.ts
  // imports this barrel (circular init crash).
  external?: boolean;
}

export const DASHBOARDS: DashboardOption[] = [
  {
    value: 'analytics',
    name: 'Enter Analytics Dashboard',
    description:
      'View insights on Service member user engagement and usage patterns.'
  },
  {
    value: 'manager',
    name: 'Enter Administration Portal',
    description:
      'Invite new members, manage permissions, and review account statuses.'
  }
];
